import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Andrés R.',
  location: 'Argentina'
}, {
  name: 'María C.',
  location: 'México'
}, {
  name: 'Juan P.',
  location: 'Colombia'
}, {
  name: 'Fernando L.',
  location: 'Chile'
}, {
  name: 'Valeria T.',
  location: 'Perú'
}, {
  name: 'Carlos R.',
  location: 'Uruguay'
}, {
  name: 'Sofía M.',
  location: 'Ecuador'
}, {
  name: 'Daniel G.',
  location: 'Venezuela'
}, {
  name: 'Laura P.',
  location: 'Guatemala'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[260px]" data-id="element-187">
      <div className="bg-brand-card rounded border border-brand-accent/30 p-3 flex items-start gap-3 shadow-lg" data-id="element-188">
        <div className="shrink-0 mt-0.5" data-id="element-189">
          <CheckCircle className="w-5 h-5 text-brand-success" data-id="element-190" />
        </div>
        <div data-id="element-191">
          <p className="text-xs text-brand-text leading-tight mb-1" data-id="element-192">
            <span className="font-bold" data-id="element-193">{currentPurchase.name}</span> de{' '}
            {currentPurchase.location} acaba de comprar el Kit Filosofía 📜
          </p>
          <p className="text-[10px] text-brand-text/60 font-bold" data-id="element-194">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-195">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}